import React, { useContext, useEffect} from 'react';
import { PostsContext } from '../App';
import { db } from '../Auth/FirebaseConfig';
import Post from '../Post/Post';
 


const AllMyPost = ({user}) => {
  const [posts, setPosts] = useContext(PostsContext)

    
         useEffect(() => {
          db.collection('posts').onSnapshot(snapshot => {
              setPosts(snapshot.docs.map(doc => ({
                  id: doc.id,
                  post: doc.data(),
                })
             ));
          }) 
      }, [setPosts]);
 
    return (
        <div>
        {
          posts.map(({ id, post }) => 
              <Post key={id} postId={id} user={user} proName={post.proName} postMessage={post.postMessage} 
                    proImage={post.proImage} postDate={post.postDate}  postVideo={post.postVideo}
                     postImage={post.postImage} noLikes={post.noLikes} postUserId={post.uid} />       
          )
        }
        </div>
    );
}; 

export default AllMyPost;  